function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import PropTypes from 'prop-types';
import React, { useEffect, useState, forwardRef } from 'react';
import { FormLegend } from '@unite-us/ui';
import SurveyJSFormRenderer from '@unite-us/surveyjs/dist/components/Renderer/SurveyJSFormRenderer';
import { isArray, isEmpty } from 'lodash';
import { TYPES, singletonAnswers } from './constants';
var ScreeningFormRenderer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var screening = _ref.screening,
    template = _ref.template,
    editMode = _ref.editMode;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    formSubmission = _useState2[0],
    setFormSubmission = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    surveyJSON = _useState4[0],
    setSurveyjJSON = _useState4[1];
  var checkAnswers = function checkAnswers(value, questionId) {
    var matchingWords = [];
    if (!isEmpty(value) && isArray(value)) {
      var commonElements = value.filter(function (element) {
        return idSingletonAnswer && idSingletonAnswer.includes(element);
      });
      commonElements.forEach(function (id) {
        if (matchingWords.length === 0) {
          var _questions$find;
          var option = (_questions$find = questions.find(function (question) {
            return question.id === questionId;
          })) === null || _questions$find === void 0 ? void 0 : _questions$find.options.find(function (option) {
            return option.id === id;
          });
          if (option && singletonAnswers.includes(option.value)) {
            matchingWords.push(option.value);
          }
        }
      });
      if (commonElements.length >= 2 || commonElements.length === 1 && value.length > 1) {
        setError(true);
        return "You've selected \"".concat(matchingWords[0], "\". Please remove other choices selected to proceed.");
      }
      setError(false);
    }
    return false;
  };
  var validateFields = function validateFields(value, questionId) {
    return checkAnswers(value, questionId);
  };
  var handleSetSurvey = function handleSetSurvey(survey) {
    ref.current = survey;
  };
  var getSingleValue = function getSingleValue(options, answer, type) {
    if (type === TYPES.TEXT || type === TYPES.COMMENT) {
      return answer.string;
    }
    if (type === TYPES.DATE || type === TYPES.NUMBER) {
      return answer.value;
    }
    if (type === TYPES.HTML) {
      return null;
    }
    if (type === TYPES.DROPDOWN || type === TYPES.RADIOGROUP || type === TYPES.SELECT) {
      return options.find(function (option) {
        return option.id === answer.option_id;
      }).value.replace(/,/g, '');
    }
    return answer && answer.id;
  };
  var getValue = function getValue(question, type) {
    if (!isEmpty(question.answer) || !isEmpty(question.answers)) {
      if (type === TYPES.DROPDOWN_MULTISELECT || type === TYPES.CHECKBOX || type === TYPES.SELECT_MULTIPLE) {
        var values = question.answers.map(function (answer) {
          return question.options.find(function (option) {
            return option.id === answer.option_id;
          }).value.replace(/,/g, '');
        });
        return values;
      }
      return getSingleValue(question.options, question.answer, question.answer.type);
    }
    return undefined;
  };
  var getDisplayValue = function getDisplayValue(question, type) {
    if (!isEmpty(question.answer) || !isEmpty(question.answers)) {
      var _question$answer, _question$answer4;
      if (type === TYPES.DROPDOWN_MULTISELECT || type === TYPES.CHECKBOX || type === TYPES.SELECT_MULTIPLE) {
        return question.answers && question.answers.map(function (item) {
          return item.string;
        }).join(', ');
      }
      if (type === TYPES.DATE && !isEmpty((_question$answer = question.answer) === null || _question$answer === void 0 ? void 0 : _question$answer.value)) {
        var _question$answer2;
        var date = new Date((_question$answer2 = question.answer) === null || _question$answer2 === void 0 ? void 0 : _question$answer2.value);
        return date.toLocaleDateString('en-US', {
          timeZone: 'UTC',
          // Ensures the date is treated in UTC
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        });
      }
      if (type === TYPES.NUMBER) {
        var _question$answer3;
        return (_question$answer3 = question.answer) === null || _question$answer3 === void 0 ? void 0 : _question$answer3.value;
      }
      return (_question$answer4 = question.answer) === null || _question$answer4 === void 0 ? void 0 : _question$answer4.string;
    }
    return '-';
  };
  useEffect(function () {
    var responses = [];
    if (!isEmpty(screening) && !isEmpty(screening.questions)) {
      responses = screening.questions.map(function (question) {
        var _question$answer5, _question$answers;
        return {
          id: question.id,
          name: question.id,
          title: question.primary_text,
          value: getValue(question, question.type),
          valueId: ((_question$answer5 = question.answer) === null || _question$answer5 === void 0 ? void 0 : _question$answer5.id) || ((_question$answers = question.answers) === null || _question$answers === void 0 ? void 0 : _question$answers.id),
          displayValue: getDisplayValue(question, question.type)
        };
      });
    }
    var form = {
      responses: responses
    };
    setFormSubmission(form);
  }, [screening]);
  useEffect(function () {
    if (!isEmpty(template)) {
      var surveyJSONObject = {
        configuration: _objectSpread({}, template.survey_json)
      };
      setSurveyjJSON(surveyJSONObject);
    }
  }, [template]);

  // NEED TO ADD THIS
  // validate={(value) => validateFields(value, question.id)
  return /*#__PURE__*/React.createElement("div", {
    className: "screening-form"
  }, editMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormLegend, null), /*#__PURE__*/React.createElement("hr", {
    className: "mt-1 mb-4"
  })), surveyJSON && /*#__PURE__*/React.createElement(SurveyJSFormRenderer, {
    formData: surveyJSON,
    formSubmission: formSubmission,
    editMode: editMode,
    handleSetSurveyModel: handleSetSurvey
  }));
});
ScreeningFormRenderer.propTypes = {
  fields: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
  editMode: PropTypes.bool
};
export default ScreeningFormRenderer;
//# sourceMappingURL=ScreeningFormRenderer.js.map